// src/Login.js
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../firebase";
import {Button} from "react-bootstrap";

function PersonalLogin({onLogin}) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      onLogin(userCredential.user);
      console.log("로그인 성공 :");
      navigate("/payment");
    } catch (err) {
      console.log("로그인 에러 :", err);
      setError("로그인 실패!");
    }
  };

  return (
    <main>
      <section className="p-0 d-flex align-items-center position-relative overflow-hidden min-vh-100">
        <div className="container-fluid g-0">
          <div className="row">
            {/* 왼쪽 이미지 영역 */}
            <div className="col-12 col-lg-6 d-md-flex align-items-center justify-content-center bg-primary bg-opacity-10 vh-lg-100">
              <div className="p-3 p-lg-5 text-center">
                <h2 className="fw-bold">Welcome to our programming language world!</h2>
                <p className="mb-0 h6 fw-light">Let&apos;s study something new today!</p>
                <img src="/assets/images/element/02.svg" className="mt-5" alt="illustration" />
                <div className="d-sm-flex mt-5 align-items-center justify-content-center">
                  <ul className="avatar-group mb-2 mb-sm-0 list-unstyled d-flex">
                    <li className="avatar avatar-sm">
                      <img className="avatar-img rounded-circle" src="/assets/images/avatar/01.jpg" alt="avatar1" width={40} />
                    </li>
                    <li className="avatar avatar-sm">
                      <img className="avatar-img rounded-circle" src="/assets/images/avatar/02.jpg" alt="avatar2" width={40} />
                    </li>
                    <li className="avatar avatar-sm">
                      <img className="avatar-img rounded-circle" src="/assets/images/avatar/03.jpg" alt="avatar3" width={40} />
                    </li>
                    <li className="avatar avatar-sm">
                      <img className="avatar-img rounded-circle" src="/assets/images/avatar/04.jpg" alt="avatar4" width={40} />
                    </li>
                  </ul>
                  <p className="mb-0 h6 fw-light ms-3">2k+ Students joined us, now it&apos;s your turn.</p>
                </div>
              </div>
            </div>

            {/* 오른쪽 로그인 폼 */}
            <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center py-5">
              <div className="col-sm-10 col-xl-8">
                <span className="mb-0 fs-1">👋</span>
                <h1 className="fs-2">개인 학습자 로그인</h1>
                <p className="lead mb-0">라이선스 구매, 결제, 취소를 위한 로그인</p>
                <p className="lead mb-4">학습 시작은 앱에서 로그인</p>

                <form onSubmit={handleSubmit}>
                  {/* 에러 메시지 */}
                  {error && (
                    <div className="alert alert-danger text-center py-2">{error}</div>
                  )}

                  {/* 이메일 */}
                  <div className="mb-4">
                    <label htmlFor="email" className="form-label">이메일 계정 *</label>
                    <div className="input-group input-group-lg">
                      <span className="input-group-text bg-light border-0 text-secondary px-3">
                        <i className="bi bi-envelope-fill"></i>
                      </span>
                      <input
                        id="email"
                        type="email"
                        autoComplete="off"
                        className="form-control border-0 bg-light rounded-end ps-1"
                        placeholder="E-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {/* 비밀번호 */}
                  <div className="mb-4">
                    <label htmlFor="password" className="form-label">비밀번호 *</label>
                    <div className="input-group input-group-lg">
                      <span className="input-group-text bg-light border-0 text-secondary px-3">
                        <i className="fas fa-lock"></i>
                      </span>
                      <input
                        id="password"
                        type="password"
                        autoComplete="new-password"
                        className="form-control border-0 bg-light rounded-end ps-1"
                        placeholder="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  {/* 로그인 버튼 */}
                  <div className="d-grid justify-content-center">
                    <Button
                      type="submit"
                      variant="primary"
                      size="lg"
                      className="mb-0"
                    >
                      로그인
                    </Button>
                  </div>
                </form>

                {/* 회원가입 링크 */}
                <div className="mt-4 text-center">
                  <p>계정이 없으세요? <a href="/personalRegistration">회원가입하기</a></p>
                  <p>비밀번호 재설성은? <a href="https://chocopython.org">학습앱에서 재설정</a></p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}

export default PersonalLogin;
